module.exports = __webpack_public_path__ + "img/コンピュータのしくみI_4_13.81998dad.jpeg";